import { ReactNode, createContext, useCallback, useContext, useMemo, useState } from 'react';

export interface IDisputeSelectorProps {
  children: ReactNode;
}

export interface IDisputeSelectorData {
  isShowModal: boolean;
  isLoadingDispute: boolean;
  setIsLoadingDispute(status: boolean): void;
  showDispute(): void;
  closeDispute(): void;
}

export const DisputeSelectorContext = createContext<IDisputeSelectorData>(null);

export const DisputeSelector = ({ children }: IDisputeSelectorProps) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [isLoadingDispute, setIsLoadingDispute] = useState<boolean>(false);

  const showDispute = useCallback(() => {
    setIsShowModal(true);
  }, []);

  const closeDispute = useCallback(() => {
    setIsShowModal(false);
  }, []);

  const value = useMemo(
    () => ({
      isShowModal,
      isLoadingDispute,
      setIsLoadingDispute,
      showDispute,
      closeDispute,
    }),
    [isShowModal, isLoadingDispute, setIsLoadingDispute, showDispute, closeDispute]
  );

  return <DisputeSelectorContext.Provider value={value}>{children}</DisputeSelectorContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export function useDisputeSelector() {
  const context = useContext(DisputeSelectorContext);

  if (!context) {
    throw new Error(`No Contract selector compound components cannot be rendered outside the No Contract Selector component`);
  }
  return context;
}
